import css from 'styled-jsx/css';
import { sansSerif } from 'styles/css-constants';
import { warmGrays } from 'styles/colors/constants';
import { MQ_LARGE } from 'constants/mq';

export default css`
  .SiteHeaderNewsletter {
    display: flex;
  }

  .SiteHeaderNewsletter__link {
    display: flex;
    align-items: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    color: ${warmGrays[7]};
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg3);
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .SiteHeaderNewsletter__link:hover {
    color: ${warmGrays[9]};
  }

  @supports (display: grid) {
    @media screen and ${MQ_LARGE} {
      .SiteHeaderNewsletter__link {
        font-size: var(--fontScaleNeg2);
      }
    }
  }
`;
